export interface MeetingModel {
    meeting_setting: any;
    timing_blocks: any;
    unavailable_dates: any;
}

export class Meeting {
    public id: string;
    public max_time: string;
    public hour_selected: string;
    public date_selected: string;
    public is_accepted: boolean;
    public meeting_link: string;
    public user_data: any;
    public deal_name: string;
    public deal_id: string;

    public startHour: Date;
    public endHour: Date;
    constructor(
        id: string,
        max_time: string,
        hour_selected: string,
        date_selected: string,
        is_accepted: boolean,
        meeting_link: string,
        user_data: any,
        deal_name: string,
        deal_id: string,
        startHour: Date,
        endHour: Date
    ) {
        this.id = id;
        this.max_time = max_time;
        this.hour_selected = hour_selected;
        this.date_selected = date_selected;
        this.is_accepted = is_accepted;
        this.meeting_link = meeting_link;
        this.user_data = user_data;
        this.deal_name = deal_name;
        this.deal_id = deal_id;

        this.startHour = startHour;
        this.endHour = endHour;
    }
}
